<ul>
    <li [class.disabled]="isPage(1)" (click)="setPage(page - 1)">←</li>
    <li *ngFor="let p of pages"
        (click)="setPage(p)"
        [class.active]="isPage(p)"
        [class.dot]="!p">
        {{p || '...'}}
    </li>
    <li [class.disabled]="isPage(pagesCount)" (click)="setPage(page + 1)">→</li>
</ul>